import React from "react"
import styled from "styled-components"
import { Button } from "../elements/button"
import cardImageLeft from "../assets/images/shipwreck/8f49e435-da2a-477b-ae77-99ddc8c34c8d.jpg"
// HAIDAWAY HIDDEN (temporary): restore this import when re-enabling Haidaway Cottage
// import cardImageRight from "../assets/images/haida-ext.jpg"

const CabinsFullWidth = () => {
  return (
    <FullWidthContainer>
      <CabinContainer>
        <FullWidthCabinCard>
          <CardBackground
            css={`
              background-image: url(${cardImageLeft});
            `}
          />
          <AboutCard>
            <TextWrap>
              <ProductTitle>Shipwreck Cabin</ProductTitle>
              <ProductSubTitle>Studio</ProductSubTitle>
            </TextWrap>
            <ViewMore to="/shipwreckcabin/" primary="true" round="true">
              View Details
            </ViewMore>
          </AboutCard>
        </FullWidthCabinCard>
      </CabinContainer>
      {/* HAIDAWAY HIDDEN (temporary): restore this card when re-enabling Haidaway Cottage
      <CabinContainer>
        <FullWidthCabinCard>
          <CardBackground
            css={`
              background-image: url(${cardImageRight});
            `}
          />
          <AboutCard>
            <TextWrap>
              <ProductTitle>Haidaway Cottage</ProductTitle>
              <ProductSubTitle>2 Bedroom</ProductSubTitle>
            </TextWrap>
            <ViewMore to="/haidawaycottage/" primary="true" round="true">
              View Details
            </ViewMore>
          </AboutCard>
        </FullWidthCabinCard>
      </CabinContainer>
      */}
    </FullWidthContainer>
  )
}

export default CabinsFullWidth

const FullWidthContainer = styled.div`
  width: 100%;
  background: #fcfcfc;
  color: #000;
  min-height: 370px;
  display: grid;
  grid-template-columns: 1fr; /* HAIDAWAY HIDDEN: was "1fr 1fr" for two properties */
  padding: 0;
  overflow: hidden;

  @media screen and (max-width: 868px) {
    grid-template-columns: 1fr;
    min-height: 500px;
  }
`

/* Background image lives in its own layer so only it zooms on hover — the
   title and "View Details" button stay put. */
const CardBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-position: center;
  background-size: cover;
  transition: transform 0.5s ease;
`

const FullWidthCabinCard = styled.div`
  border: 1px solid #fff;
  width: 100%;
  height: 400px;
  position: relative;
  overflow: hidden;

  &:hover ${CardBackground} {
    transform: scale(1.1);
  }
`

const CabinContainer = styled.div`
  overflow: hidden;
  height: 100%;
`

const AboutCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 2rem;

  @media screen and (max-width: 280px) {
    padding: 0 1rem;
  }
`

const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 120px;
  z-index: 1;
`

const ProductTitle = styled.h3`
  color: #fff;
  font-weight: 400;
  font-size: clamp(1rem, 5vw, 1.7rem);
  margin-bottom: 1rem;
  margin-left: 0.5rem;
  text-shadow: 2px 2px 4px #000000;
`

const ProductSubTitle = styled.h3`
  color: #fff;
  font-weight: 400;
  font-size: clamp(1rem, 5vw, 1.7rem);
  margin-left: 0.5rem;
  text-shadow: 2px 2px 4px #000000;
`

const ViewMore = styled(Button)`
  font-size: 14px;
  position: absolute;
  top: 220px;
  z-index: 1;
`
